import {IComponentController, IRootElementService} from "angular";
import {Branch} from "../../../branches/model/Branch";
import {BranchesService} from "../../../branches_service/service/branches-service";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";

import './employeeBranchSelector.scss';
import {SelectableBranch} from "../../model/SelectableBranch";


export abstract class EmployeeBranchSelector implements IComponentController {

    protected onValueChange: (value: number[]) => void;
    protected multipleSelect: boolean;
    protected loaded = false;
    protected selectedBranchesId = [];
    protected branchQuery: string;
    protected branchesList: SelectableBranch[];

    branchesChange: (selectedBranches: Branch[]) => void;

    constructor(private branchesService: BranchesService,
                private toastNotificationService: ToastNotificationService,
                private $element: IRootElementService) {
        this.toastNotificationService = toastNotificationService;
        this.branchesService = branchesService;
        this.$element = $element;
    }

    $onInit(): void {
        this.fetchBranches();
        this.$element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
        this.loaded = true;
    }


    protected clearSearchTerm = () => {
        this.branchQuery = '';
    };

    protected updateSelectedBranches() {
        this.onValueChange && this.onValueChange(this.selectedBranchesId);
        let selectedBranches = this.branchesList.filter(b => this.selectedBranchesId.includes(b.branchName));
        this.onSelectedBranches(selectedBranches)
    };

    protected onSelectedBranches = (selectedBranches: Branch[]) => {
        this.branchesChange && this.branchesChange(selectedBranches);
    };

    protected fetchBranches = () => {
        this.branchesService.getAutocompleteBranches()
            .then(resp => {
                if (resp.status === 200) {
                    this.branchesList = resp.data.map(branch => ({selected: false, ...branch}));
                }
            }, err => {
                this.toastNotificationService.generateErrorMessage("Failed to fetch the branches!")
            })
    };

}